// extracted by mini-css-extract-plugin
module.exports = {"root":"popular_root__3dD44","list":"popular_list__3RkmX","loader":"popular_loader__1dHGR"};